export const styles = {
  container:
    'tw-flex tw-flex-col tw-gap-1 tw-p-3 tw-min-w-0 tw-h-full tw-border-solid tw-border tw-border-neutral-200 tw-rounded tw-bg-white tw-overflow-hidden',
  info: 'tw-flex tw-flex-col tw-gap-1.5 tw-min-w-0',
  name: 'tw-text-sm tw-font-medium tw-text-neutral-800 tw-break-words tw-block',
  value: 'tw-text-xs tw-text-neutral-500 tw-break-words tw-block tw-mt-0',
};
